import styled from '@emotion/styled'
import { width } from 'styled-system'

import { H1 } from '../../Common/Typography'

export const StyledTitle = styled(H1)`
  width: fit-content;
`
